import { handleActions } from 'redux-actions';
import { fromJS, Map } from 'immutable';

import actions from '../actions';

//REDUCERS
const { corporate: corporateActions } = actions.customer;

export default handleActions(
  {
    [corporateActions.setPayforms.toString()]: (user, { payload }) => {
      return user && user.set('pay_forms', payload);
    },
    [corporateActions.setPayformsAsync.toString()]: (user, { payload }) => {
      return user && user.set('pay_forms', payload);
    },
    [corporateActions.get.toString()]: (user, { payload }) => {
      return fromJS(payload);
    },
    [corporateActions.getUserAsync.toString()]: (user, { payload }) => {
      return fromJS(payload);
    },
    [corporateActions.update.toString()]: (user, { payload }) => {
      return fromJS(payload);
    }
  },
  Map()
);
